import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTypography from './MuiTypography';
import MuiCssBaseline from './MuiCssBaseline';
import MuiFormControl from './MuiFormControl';
import MuiTableRow from './MuiTableRow';
import MuiLink from './MuiLink';

export default {
  MuiFormControl,
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiTableCell,
  MuiTableHead,
  MuiTableRow,
  MuiTypography,
  MuiPopover: {
    paper: {
      // boxShadow: 'none'
    }
  },
  MuiLink,
  MuiCssBaseline
};
